// src/js/components/variant-selects.js
if (!customElements.get("variant-selects")) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectionMetadata(event);
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues
          }
        });
      });
    }
    updateSelectionMetadata({ target }) {
      const { value, tagName } = target;
      if (tagName === "SELECT" && target.selectedOptions.length) {
        Array.from(target.options).find((option) => option.getAttribute("selected")).removeAttribute("selected");
        target.selectedOptions[0].setAttribute("selected", "selected");
        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = target.closest(".product-form__input").querySelector("[data-selected-value] > .swatch");
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue);
          selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
        } else {
          selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset");
          selectedDropdownSwatchValue.classList.add("swatch--unavailable");
        }
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch-focal-point",
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
        );
      } else if (tagName === "INPUT" && target.type === "radio") {
        const selectedSwatchValue = target.closest(`.product-form__input`).querySelector("[data-selected-value]");
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      }
    }
    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }
    get selectedOptionValues() {
      return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
  }
  customElements.define("variant-selects", VariantSelects);
}
